module.exports = __webpack_public_path__ + "./images/2.80d2a4c7c51366343ed4b507b70359f7.png";